import { eventsService } from '../_services';

export const VALID_EVENTS = ['open', 'click', 'unsubscribe', 'unsubscribe_click', 'bounce', 'delivered'];
export const [OPEN, CLICK, UNSUBSCRIBE, UNSUBSCRIBE_CLICK, BOUNCE, DELIVERED] = VALID_EVENTS;

const state = {
  filteredItems: [],
  filteredLoading: false,
  count: 0,
  loading: false,
  clickedLinks: [],
  clickedLinksCount: 0,
  clientOpens: [],
  clientOpensCount: 0,
};

const actions = {
  fetchClickedLinks({ commit }, { outreach, page, page_size }) {
    commit('updateLoading', true);
    return eventsService.fetchClickedLinks(outreach, page, page_size).then((response) => {
      // eslint-disable-next-line no-unused-expressions, no-sequences
      commit('updateClickedLinks', response.data.results),
      commit('updateClickedLinksCount', response.data.count);
      return response;
    }).finally(() => {
      commit('updateLoading', false);
    });
  },
  fetchClientOpens({ commit }, { outreach, page, page_size }) {
    commit('updateLoading', true);
    return eventsService.fetchClientOpens(outreach, page, page_size).then((response) => {
      // eslint-disable-next-line no-unused-expressions, no-sequences
      commit('updateClientOpens', response.data.results),
      commit('updateClientOpensCount', response.data.count);
      return response;
    }).finally(() => {
      commit('updateLoading', false);
    });
  },
  addClickedLinks({ commit }, { outreach, page, page_size }) {
    commit('updateLoading', true);
    return eventsService.fetchClickedLinks(outreach, page, page_size).then((response) => {
      // eslint-disable-next-line no-unused-expressions, no-sequences
      commit('pushClickedLinks', response.data.results),
      commit('updateClickedLinksCount', response.data.count);
      return response;
    }).finally(() => {
      commit('updateLoading', false);
    });
  },
  addClientsOpens({ commit }, { outreach, page, page_size }) {
    commit('updateLoading', true);
    return eventsService.fetchClientOpens(outreach, page, page_size).then((response) => {
      // eslint-disable-next-line no-unused-expressions, no-sequences
      commit('pushClientOpens', response.data.results),
      commit('updateClientOpensCount', response.data.count);
      return response;
    }).finally(() => {
      commit('updateLoading', false);
    });
  },
  fetchFiltered({ commit }, filters) {
    commit('updateFilteredLoading', true);
    eventsService.fetchFiltered(filters).then((response) => {
      commit('updateFiltered', response.data.results);
      commit('updateCount', response.data.count);
    }).finally(() => {
      commit('updateFilteredLoading', false);
    });
  },
  reset({ commit }) {
    commit('reset');
  },
};

const mutations = {
  reset(state) {
    state.filteredItems = [];
    state.filteredLoading = false;
    state.count = 0;
    state.loading = false;
    state.clickedLinks = [];
    state.clickedLinksCount = 0;
    state.clientOpens = [];
    state.clientOpensCount = 0;
  },
  updateLoading(state, isLoading) {
    state.loading = isLoading;
  },
  updateClickedLinks(state, items) {
    state.clickedLinks = items;
  },
  updateClickedLinksCount(state, count) {
    state.clickedLinksCount = count;
  },
  updateClientOpens(state, items) {
    state.clientOpens = items;
  },
  updateClientOpensCount(state, count) {
    state.clientOpensCount = count;
  },
  updateFiltered(state, items) {
    state.filteredItems = items;
  },
  updateFilteredLoading(state, isLoading) {
    state.filteredLoading = isLoading;
  },
  updateCount(state, count) {
    state.count = count;
  },
  resetFiltered(state) {
    state.count = 0;
    state.filteredItems = [];
  },
  pushClickedLinks(state, items) {
    state.clickedLinks.push(...items);
  },
  pushClientOpens(state, items) {
    state.clientOpens.push(...items);
  },
};

export const events = {
  namespaced: true,
  state,
  actions,
  mutations,
};
